import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NameSectionForm from '../../../../../ReusableFormSections/NameSection/NameSectionForm'

import { clearUpdateCampaign, updateCampaign } from '../../../../../../modules/actions/campaigns'
import {
  campaignUpdateErrorSelector,
  campaignUpdateIsLoadingSelector,
  campaignWasUpdatedSelector
} from '../../../../../../modules/selectors/campaigns'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { GOOGLE_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const NameSection = ({ editItemData: campaign, title, ...formProps }) => {
  const dispatch = useDispatch()

  const campaignWasUpdated = useSelector(campaignWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const handleSubmit = useCallback(
    values => {
      const updateCampaignData = {
        account: selectedAdAccountId,
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        },
        ...values
      }

      dispatch(updateCampaign(updateCampaignData, campaign.id, GOOGLE_PLATFORM))
    },
    [dispatch, campaign.id, title, selectedAdAccountId]
  )

  const handleClearUpdateCampaign = useCallback(() => {
    dispatch(clearUpdateCampaign())
  }, [dispatch])

  return (
    <NameSectionForm
      placeholder="Campaign Name"
      editItem={campaign}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearUpdateCampaign}
      successSubmit={campaignWasUpdated}
      isLoadingSelector={campaignUpdateIsLoadingSelector}
      errorSelector={campaignUpdateErrorSelector}
      {...formProps}
    />
  )
}

export default NameSection
